import React from 'react'

const TabItemLink = ({id, text}) => {  
  return(
    <a className={`tab__item__link`} href={`#translation-${id}`} key={id}>{text}</a>
  )
}

export default TabItemLink;